export const LEARNER_SESSION_TOKEN_LOCAL_STORAGE_NAME = "learnerJWT";
export const LEARNER_REFRESH_TOKEN_LOCAL_STORAGE_NAME = "learnerRefreshJWT";
export const PARENT_TRANSFER_TOKEN_COOKIE_NAME = "parentToken";
